exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Unsupported-style {\n  font-size: 14px;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  line-height: 18.5714px;\n  background-color: #AA5939;\n  color: #FBEDE7;\n  width: '100%';\n  margin-top: 20px; }\n", ""]);

// exports
